import {observer} from 'mobx-react';
import React from 'react';
import {BookmarkItem as IBookmarkItem, HistoryItem, MemoryItemConversionType} from '../../stores/MemoryBarStore';
import {px} from 'csx';
import MemoryItemOptionRows from './MemoryItemOptionRows';
import {classes, stylesheet} from 'typestyle';
import {KPI} from '../../kpi';
import {BlackColorFaded10, BlackColorFaded20, WhiteColor} from '../../styles/colors';

interface BookmarkItemProps {
    disabled?: boolean;
    data: IBookmarkItem;
    memoryItemConversionOccured: (conversionType: MemoryItemConversionType) => void;
    index: number;
    degradeBookmarkToHistoryItem: (bookmarkItem: IBookmarkItem) => void;
    onClick?: (historyItem: HistoryItem) => void;
    getAttributeNameIfPossible: (kpi: KPI) => string;
}

@observer
export default class BookmarkItem extends React.Component<BookmarkItemProps, {detailIsVisible: boolean}> {
    public state = {
        detailIsVisible: false,
    };

    public toggleDetails = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            detailIsVisible: !this.state.detailIsVisible,
        });
    };

    public degradeToHistoryItem = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.disabled) {
            return;
        }

        this.props.degradeBookmarkToHistoryItem(this.props.data);
        this.props.memoryItemConversionOccured(MemoryItemConversionType.TO_HISTORY);
    };

    public applyBookmarkSettings = (e: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.onClick && !this.props.disabled) {
            e.preventDefault();
            e.stopPropagation();
            this.props.onClick(this.props.data);
        }
    };

    public render() {
        const textStyle: React.CSSProperties = {
            textAlign: this.state.detailIsVisible ? 'left' : 'center',
            lineHeight: this.state.detailIsVisible ? 'normal' : px(50),
        };

        return (
            <div className={classes(bookmarkCss.item, this.props.disabled ? 'disabled' : undefined)} onClick={this.applyBookmarkSettings}>
                <div style={textStyle}>{this.props.data.name}</div>
                <div className={bookmarkCss.itemFoldout} onClick={this.toggleDetails}>
                    <i className={`fa fa-chevron-${this.state.detailIsVisible ? 'up' : 'down'}`} />
                </div>
                <div className={bookmarkCss.convertToHistory} onClick={this.degradeToHistoryItem}>
                    <i className="fa fa-star" />
                </div>
                {this.state.detailIsVisible ? (
                    <MemoryItemOptionRows {...this.props.data} getAttributeNameIfPossible={this.props.getAttributeNameIfPossible} />
                ) : null}
            </div>
        );
    }
}

const bookmarkCss = stylesheet({
    item: {
        position: 'relative',
        paddingTop: 5,
        paddingLeft: 5,
        paddingBottom: 5,
        paddingRight: 5,
        minHeight: 50,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
        backgroundColor: WhiteColor,
        borderRadius: 2,
        $nest: {
            '&.disabled': {
                opacity: 0.6,
            },
        },
    },
    itemFoldout: {
        zIndex: 2,
        position: 'absolute',
        bottom: 0,
        fontSize: px(12),
        right: 0,
        display: 'inline-block',
        width: 25,
        textAlign: 'center',
        lineHeight: px(25),
        height: 25,
        marginLeft: 5,
        borderRadius: 2,
        $nest: {
            '&:hover': {
                background: BlackColorFaded20,
            },
        },
    },
    convertToHistory: {
        cursor: 'pointer',
        borderRadius: 2,
        width: 25,
        height: 25,
        zIndex: 2,
        lineHeight: px(25),
        textAlign: 'center',
        position: 'absolute',
        right: 0,
        top: 0,
        fontSize: px(14),
        $nest: {
            '&:hover': {
                background: BlackColorFaded10,
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/views/MemoryBar/BookmarkItem.tsx